import { render, staticRenderFns } from "./Texture.vue?vue&type=template&id=efb5e282&"
import script from "./Texture.vue?vue&type=script&lang=js&"
export * from "./Texture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports